import * as React from "react"
import {
    DataGrid,
} from "@mui/x-data-grid"
import { AXIOS_API_INSTANCE } from "../Constants"
import { send_authorized_request } from "../Constants/cognito"

import CustomerModal from "./CustomerModal"
import { SimpleCustomToolbar } from "./CustomToolbar"
import onFilterChange from "../Utils/OnFilterChange"
import { Box, Button, Chip } from "@mui/material"
import Grid from "@mui/material/Grid2"
import SearchIcon from '@mui/icons-material/Search';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import DocumentTitle from "../Utils/DocumentTitle"
import { formatPhoneNumber, widthChangeEvent } from "../Utils"
import { useSnackbar } from "notistack"
import CustomerSearchModal from "./modals/CustomerSearchModal"

const columns = [
    {
        field: "name",
        headerName: "Name",
        minWidth: 200,
        flex: 1,
        editable: false,
    },
    {
        field: "company_name",
        headerName: "Company",
        minWidth: 150,
        flex: 1,
        editable: false,
    },
    {
        field: "email",
        headerName: "Email",
        minWidth: 150,
        flex: 1,
        editable: false,
    },
    {
        field: "phone",
        headerName: "Phone",
        minWidth: 150,
        flex: 1,
        editable: false,
        valueFormatter: (value) => formatPhoneNumber(value)
    },
    {
        field: "city",
        headerName: "City",
        minWidth: 150,
        flex: 1,
        editable: false,
    },
    {
        field: "state",
        headerName: "State",
        minWidth: 75,
        flex: 1,
        editable: false,
    },
    {
        field: "zip",
        headerName: "Zip",
        minWidth: 100,
        flex: 1,
        editable: false,
    }
]

export default function Customers(props) {
    DocumentTitle('Customers')
    const { enqueueSnackbar } = useSnackbar();
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: parseInt(localStorage.getItem(`customers:pageSize`) || 10),
        page: 0,
    });
    const [rowData, setRowData] = React.useState({ rows: [], total_count: 0 })
    const [sorting, setSorting] = React.useState({ field: 'id', sort: 'asc' })
    const [filtering, setFiltering] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(true)
    const [customerModal, setCustomerModal] = React.useState({
        open: false,
        customer: {},
        creatingNewCustomer: false,
    })
    const [customerSearchModalOpen, setCustomerSearchModalOpen] = React.useState(false)
    const [customerSearch, setCustomerSearch] = React.useState([])
    const [windowInnerWidth, setWindowInnerWidth] = React.useState(window.innerWidth)
    console.log("RENDERING Customers")

    const customerRowClick = (params) => {
        setCustomerModal({
            customer: params.row,
            open: true,
            creatingNewCustomer: false,
        })
    }
    const createCustomerClick = (params) => {
        setCustomerModal({
            customer: {
                company_name: '',
                name: '',
                address_1: '',
                address_2: '',
                city: '',
                state: '',
                zip: '',
                phone: '',
                email: '',
                preferred_communication_type: 'text',
            },
            open: true,
            creatingNewCustomer: true,
        })
    }
    const closeCustomerModal = (changes) => {
        setCustomerModal({ ...customerModal, open: false })
        if (changes) {
            getCustomers(sorting.field, sorting.sort, paginationModel, filtering)
        }
    }

    const setMyPaginationModel = (model) => {
        localStorage.setItem(`customers:pageSize`, model.pageSize)
        setPaginationModel(model)
    }

    const getCustomers = (sortField, sortDirection, paginationModel, filterVar) => {
        setIsLoading(true)
        let my_filters = Object.assign({}, filterVar);
        if (customerSearch.length > 0) {
            my_filters['and'] = customerSearch.map((search) => search.filter)
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.get("customers", {
                params: {
                    page_num: paginationModel.page,
                    page_size: paginationModel.pageSize,
                    order_by: sortField,
                    order_by_direction: sortDirection,
                    filters: JSON.stringify(my_filters),
                    check_deletable: true
                },
            }).then((customer) => {
                setRowData({
                    rows: customer.data.data,
                    total_count: customer.data.total_count,
                })
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
                enqueueSnackbar(`Failed to get customers <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        getCustomers(sorting.field, sorting.sort, paginationModel, filtering)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, sorting, filtering, customerSearch])

    React.useEffect(() => {
        return widthChangeEvent(setWindowInnerWidth)
    }, [])

    return (
        (<React.Fragment>
            <Grid container space={1} sx={{ width: '100%' }}>
                <Grid size="grow">
                    <Grid container sx={{ pb: 1, pr: 1, pl: 1 }} justifyContent={"space-between"} spacing={1} alignItems={"flex-start"}>
                        <Grid size="grow" container alignItems={'center'} spacing={1}>
                            <Grid>
                                <Button variant="contained" onClick={() => setCustomerSearchModalOpen(true)} disabled={isLoading} startIcon={<SearchIcon />}>Customer Search</Button>
                            </Grid>
                            {customerSearch.map((search, index) => {
                                var label = ''
                                if (search.type === 'phone') {
                                    label = `Phone: ${formatPhoneNumber(search.filter.or[0][Object.keys(search.filter.or[0])[0]])}`
                                } else if (search.type === 'email') {
                                    label = `Email: ${search.filter[Object.keys(search.filter)[0]]}`
                                } else if (search.type === 'name') {
                                    label = `Name: ${search.filter.or[0][Object.keys(search.filter.or[0])[0]]}`
                                }
                                return <Grid>
                                    <Chip label={label} variant="outlined" disabled={isLoading} onDelete={
                                        () => {
                                            customerSearch.splice(index, 1)
                                            setCustomerSearch([...customerSearch])
                                        }} />
                                </Grid>
                            })}
                        </Grid>
                        <Grid size="auto">
                            <Button onClick={createCustomerClick} variant="contained" color="primary"><AddCircleSharpIcon /><Box sx={{ pl: 1 }}>Add Customer</Box></Button>
                        </Grid>
                    </Grid>
                    <DataGrid
                        key={windowInnerWidth}
                        slots={{
                            toolbar: () => SimpleCustomToolbar(),
                        }}
                        rows={rowData.rows}
                        rowCount={rowData.total_count}
                        columns={columns}
                        disableRowSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        autoHeight={true}
                        filterMode={"server"}
                        loading={isLoading}
                        pageSizeOptions={[5, 10, 25, 50, 100]}
                        pagination
                        paginationMode="server"
                        paginationModel={paginationModel}
                        onPaginationModelChange={setMyPaginationModel}
                        onRowClick={customerRowClick}
                        onSortModelChange={(params) => {
                            if (params[0] !== undefined) {
                                setSorting(params[0])
                            } else {
                                setSorting({ field: 'id', sort: 'asc' })
                            }
                        }}
                        onFilterModelChange={(params) => { setFiltering(onFilterChange(params)) }}
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    // Hide columns status and traderName, the other columns will remain visible
                                    city: false,
                                    state: false,
                                    zip: false,
                                },
                            },
                        }}
                    />
                    <CustomerSearchModal
                        open={customerSearchModalOpen}
                        returnFilters={true}
                        closeModal={(results, type) => {
                            setCustomerSearchModalOpen(false)
                            if (results) {
                                setCustomerSearch(customerSearch.concat([{ filter: results, type: type }]))
                            }
                        }}
                    />
                    <CustomerModal
                        open={customerModal.open}
                        customer={customerModal.customer}
                        closeModal={closeCustomerModal}
                        creatingNewCustomer={customerModal.creatingNewCustomer}
                    />
                </Grid>
            </Grid>
        </React.Fragment>)
    );
}
